import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website'
}) => {
  const siteTitle = 'Återvinningsguiden';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const defaultDescription = 'Hitta återvinningsstationer och sorteringsguide för alla Sveriges kommuner. Gratis och alltid uppdaterat.';
  const defaultKeywords = 'återvinning, återvinningsstation, ÅVC, sorteringsguide, avfall, miljö, Sverige, kommuner';
  const baseUrl = 'http://localhost:8888';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url || baseUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url || baseUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      {image && <meta property="twitter:image" content={image} />}

      {/* Additional SEO */}
      <link rel="canonical" href={url || baseUrl} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Swedish" />
      <meta name="geo.region" content="SE" />
      <meta name="geo.placename" content="Sweden" />
    </Helmet>
  );
};

export default SEO;
